import * as TablerIcons from "vue-tabler-icons";
import { defineComponent } from "vue";

export default defineNuxtPlugin((nuxtApp) => {
  Object.keys(TablerIcons).forEach((iconName) => {
    defineComponent({
      name: iconName,
      extends: TablerIcons[iconName],
    });
  });
});
